import React from 'react';

import { Redirect } from "react-router-dom";
import CompComparativoVendas from '../../components/DashBoard/compcomparativovendas';


export default function ComparativoVendas() {
      const isLogged = !!localStorage.getItem('lukos-token');

      if (isLogged === false) {
        return(<Redirect to="/login" />)
      }
      else
      {  return (        
                    <div>
                      <CompComparativoVendas />
                  </div>
                  );
  };
}
